

  import Vue from 'vue'
  import Component from "vue-class-component";
  import {namespace} from "vuex-class";
  import {IShortUser} from "@/model/shortInterfaces";
  import {Prop, Watch} from "vue-property-decorator";
  import {IOnOffHandlers} from "bonomo/dist";
  import {IErrors} from "@/model/IErrors";

  const userModule = namespace("userModule");

  @Component({
    name: 'UserSearch',
    components: {}
  })
  export default class UserSearch extends Vue {

    @Prop({default: true}) // inverse prop!!
    protected forToolbar!: boolean;
    @Prop()
    protected errors!: IErrors;
    @Prop({default: false})
    protected autoFocus!: boolean;

    @userModule.Getter('userSearch')
    protected items!: IShortUser[];

    protected model: any = null;
    protected loading: boolean = false;
    protected search: any = null;
    protected subscribes: IOnOffHandlers = {};
    private timeout: any;

    @Watch('search')
    protected onSearch(val: string) {

      if (!this.validSearch(val)) {
        this.clear();
        return;
      }

      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(() => {
        this.loading = true;
        this.$store.dispatch('userModule/fetchUserSearch', val);
      }, 500);

    }

    created() {
      this.subscribes = this.$ons({
        'backend.call.OK.userSearchLoaded': this.onOK,
        'backend.call.KO.userSearchLoaded': this.onOK,
      });
    }

    mounted() {
      if (this.autoFocus !== false) {
        // @ts-ignore
        this.$refs['autocompleteRef'].$el.getElementsByTagName('input')[0].click();
      }
    }

    protected validSearch(search: string|null) {
      return !(search == null || search.length < 3);
    }

    protected onFocus() {
      this.clear();
    }

    protected onBlur() {
      if (!this.forToolbar) {
        this.clear();
      }
      this.$emit('blur');
    }

    protected onChange(val: IShortUser) {
      this.$emit('change', val);
    }

    private onOK() {
      this.loading = false;
    }

    private clear() {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.$store.dispatch('userModule/clearUserSearch');
    }

  }

